import { useState } from 'react'
import { GuessType, RoundType } from '../../types'
import { useMailman } from '.'

export const useGame = () => {
  const { mailman } = useMailman()
  const [rounds, setRounds] = useState<RoundType[]>([])
  const [guess, setGuess] = useState<GuessType>()

  const startGame = async (map: string) => {
    const game = await mailman('games', 'POST', { map })
    createRound(game._id)
  }

  const createRound = async (game: string) => {
    const round = await mailman('rounds', 'POST', { game })
    setRounds([...rounds, round])
  }

  const completeGame = async (game: string) => {
    await mailman('games/complete', 'POST', { game })
    setRounds([])
    setGuess(undefined)
  }

  const nextRound = async (game: string) => {
    const round = rounds[rounds.length - 1]
    
    setGuess(undefined)

    if (round.index < 2) {
      return await createRound(game)
    }

    await completeGame(game)
  }

  const submitGuess = async (amount: number) => {
    const guess = await mailman('rounds/guess', 'POST', { amount, round: rounds[rounds.length - 1]._id })
    
    setGuess({
      guess: amount,
      real: guess.value,
      score: guess.score
    })
  }

  return {
    guess,
    rounds,
    actions: {
      startGame,
      createRound,
      submitGuess,
      nextRound,
      setRounds,
      setGuess
    }
  }
}